import React, { Fragment, useEffect } from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
  useLocation,
} from "react-router-dom";

// Redux
import { connect } from "react-redux";

// Route Components
import Onboarding from "../../components/Onboarding/Onboarding";
import Login from "../../components/Login/Login";
import LandingPage from "../../components/LandingPage/LandingPage";
import Logout from "../../components/Logout/Logout";
import Profile from "./../../components/Profile/Profile";
import Recovery from "../../components/Recovery/Recovery";
import Dashboard from "../../components/Dashboard/Dashboard";
import ManageUsers from "../../components/ManageUsers/ManageUsers";
import ManageIssues from "../../components/ManageIssues/ManageIssues";
import ManageLoans from "../../components/ManageLoans/ManageLoans";
import FunderNotifications from "../../components/FunderNotifications/FunderNotifications";
import Subscriptions from "../../components/Subscriptions/Subscriptions";
import ReportIssue from "../../components/ReportIssue/ReportIssue.js";
import Notifications from "../../components/Notifications/Notifications";
import AuditTrail from "../../components/AuditTrail/AuditTrail";
import Settings from "../../components/Settings/Settings";
import Faq from "../../components/Faq/Faq";
import Notfound from "../../components/Notfound/Notfound";
import ContactUs from "../../components/ContactUs/ContactUs";
import Terms from "../Footer/Terms";
import Privacy from "../Footer/Privacy";
import ChangePassword from "../../components/ChangePassword/ChangePassword";
import ManageApproval from "../../components/ManageApproval/ManageApproval";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop.component";
import ManageRolesAndUsers from "../../components/ManageRoles/ManageRolesAndUsers";
import DisbursementApproverDashboard from "../../components/DisbursementApproverDashboard/DisbursementApproverDashboard";
import RepaymentReports from "../../components/RepaymentReports/RepaymentReports";
import Enable2FA from "../../components/Enable2FA/Enable2FA";
import CreditBureau from "../../components/CreditBureau/CreditBureau";
import protectPage from "./../../helpers/protectPage";
import AggregatorOnboarding from "./../../components/AggregatorOnboarding/AggregatorOnboarding";
import AggregatorOnboardingReview from "../../components/AggregatorOnboardingReview/AggregatorOnboardingReview";
import AggregatorOnboardingEligiblityQuestions from "./../../components/AggregatorOnboardingSettings/EligibilityQuestions/AggregatorOnboardingEligiblityQuestions";
import AggregatorOnboardingRequiredDocuments from "./../../components/AggregatorOnboardingSettings/RequiredDocuments/AggregatorOnboardingRequiredDocuments";
import GeneralPowerBiDashboard from "../../components/PowerBiDasboard/GeneralPowerBiDashboard";
import Investor from "../../components/Investor/Investor";
import InvestorTabs from "../../components/Investor/Tabs/InvestorTabs";
import InvestorInvestmentWallet from "../../components/Investor/Tabs/InvestorInvestmentWallet";
import EachInvestorInvestment from "../../components/Investor/Tabs/EachInvestorInvestment/EachInvestorInvestment";
import FunderInvestmentProduct from "../../components/FunderInvestmentProduct/FunderInvestmentProduct";
import CreateInvestmentProduct from "../../components/FunderInvestmentProduct/CreateInvestmentProducts/CreateInvestmentProduct";
import EditInvestmentProduct from "../../components/FunderInvestmentProduct/CreateInvestmentProducts/EditInvestmentProduct";
import PreviewInvesmentFunds from "../../components/FunderInvestmentProduct/CreateInvestmentProducts/PreviewInvestment/PreviewInvesmentFunds";
import ApprovalRequest from "../../components/ApprovalRequest/ApprovalRequest";
import PreviewInvestorDetails from "../../components/ApprovalRequest/Tabs/PreviewInvestorDetails";
import PreviewInvesmentFundDetails from "../../components/ApprovalRequest/Tabs/PreviewInvesmentFundDetails";
import ActiveInvestmentTab from "../../components/FunderInvestmentProduct/Tabs/ActiveInvestmentTab/ActiveInvestmentTab";
import BatchLoanRepayment from "../../components/BatchLoanRepayment/BatchLoanRepayment";
import BatchRepaymentRequest from "../../components/BatchRepaymentRequest/BatchRepaymentRequest";
import Requests from "../../components/Requests/Requests";
import PreviewOfflineInvestment from "../../components/Requests/Tabs/PreviewOfflineInvestment";
import AllInvestments from "../../components/AllInvestments/AllInvestments";
import PowerBiReport from "../../components/PowerBiDasboard/PowerBiReport";
import EachFunderInvestment from "../../components/AllInvestments/EachFunderInvestment";
import AllAggregatorTransactions from "../../components/AllTransactions/AllAggregatorTransactions";
import LoanRepaymentReport from "../../components/LoanRepaymentReport/LoanRepaymentReport";
import IncomeInterestReport from "../../components/IncomeInterestReport/IncomeInterestReport";
import Wallet from "../../components/Wallet/Wallet";
import WalletTransactions from "../../components/Wallet/WalletTransactions";
import WalletDisbursementTransactions from "../../components/WalletDisbursementApprovals/WalletDisbursementTransactions";
import WalletTransactionLog from "../../components/WalletDisbursementApprovals/WalletTransactionLog";
import Messaging from "../../components/Messaging";
import { messagingUrl } from "../../components/Messaging/urlConstants";
import SendMessage from "../../components/Messaging/SendMessage/sendMessage";
import PreviousMessages from "../../components/Messaging/PreviousMessages/previousMessages";
import ProductSetup from "../../components/ProductSetup/productSetup";
import BirthdayNotifications from "../../components/BirthdayNotifications";
import CompanyWallets from "../../components/Wallet/CompanyWallets";
import CompanyWalletTransactions from "../../components/Wallet/CompanyWalletTransactions";
import GlobalWaitlist from "../../components/AggregatorOnboarding/GlobalWaitlist/GlobalWaitlist.component";
import ViewMessage from "../../components/Messaging/ViewMessage/viewMessage";
import UploadDealSlip from "../../components/DealSlip/uploadDealSlip";
import PendingDealSlips from "../../components/DealSlip/PendingDealSlips/pendingDealSlips";
import ViewDealSlip from "../../components/DealSlip/PendingDealSlips/viewDealSlip";
import PrivateRoute from "./PrivateRoute";
import { ROLE_TYPES } from "../../helpers/roleTypes";
import AccessDenied from "../../components/AccessDenied/AccessDenied";

const AppRouter = (props) => {
  const { pathname } = useLocation();
  //  Life Cycle Hooks
  useEffect(() => {
    //  If user is logged in and user is not registered on SSO, redirect to changed password.
    // This runs anytime the url changes
    if (props.isAuthenticated) {
      if (props.loggedInUser && props.loggedInUser.ForceChangeOfPassword) {
        props.history.push("/change-password");
      }
    }
  }, [props.history, props.isAuthenticated, props.loggedInUser, pathname]);
  return (
    <Fragment>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/login/" component={Login} />
        <Route path="/landing" component={LandingPage} />
        <Route path="/onboarding/" component={Onboarding} />
        <Route path="/logout/" component={Logout} />
        <Route path="/forgot-password/" component={Recovery} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/terms-of-use" component={Terms} />
        <Route path="/page-not-found/" component={Notfound} />
        <Route path="/enable-2fa/" component={protectPage(Enable2FA)} />
        <Route path="/contact-us/" component={protectPage(ContactUs)} />
        <Route path="/profile/" component={protectPage(Profile)} />
        <Route path="/faq/" component={protectPage(Faq)} />

        {/* Might be redundant */}
        <Route path="/manage-issues/" component={protectPage(ManageIssues)} />
        <Route path="/notifications/" component={protectPage(Notifications)} />
        <Route
          path="/funder-notifications/"
          component={protectPage(FunderNotifications)}
        />
        <Route path="/subscriptions/" component={protectPage(Subscriptions)} />
        <Route path="/report-issue/" component={protectPage(ReportIssue)} />
        <Route path="/reports/" component={protectPage(RepaymentReports)} />

        {/* Pay extra attention */}
        <Route path="/audit-trail/" component={protectPage(AuditTrail)} />

        {/* Exists on the system. Couldn't find the source */}
        <Route
          path="/wallet-transactions/:id"
          component={protectPage(WalletTransactions)}
        />

        {/* Authenticated Routes */}
        <Route path="/access-denied/" component={protectPage(AccessDenied)} />
        <PrivateRoute
          permittedRoles={[ROLE_TYPES.GENERAL_DASHBOARD]}
          path="/dashboard/"
          component={protectPage(Dashboard)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.GENERAL_DASHBOARD]}
          path="/main-dashboard/"
          component={protectPage(GeneralPowerBiDashboard)}
        />
        <PrivateRoute
          permittedRoles={[ROLE_TYPES.STANDARD_LOAN_REPORT]}
          path="/main-report/"
          component={protectPage(PowerBiReport)}
        />
        <PrivateRoute
          permittedRoles={[ROLE_TYPES.DISBURSEMENT_APPROVER]}
          path="/approve-loans/"
          component={protectPage(DisbursementApproverDashboard)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.LOAN_REPAYMENT_REPORT]}
          path="/loan-repayment-reports/"
          component={protectPage(LoanRepaymentReport)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.STANDARD_LOAN_REPORT]}
          path="/loan-income-interest-reports"
          component={protectPage(IncomeInterestReport)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.AGGREGATOR_VIEWER]}
          path="/manage-ecosystems/"
          component={protectPage(ManageUsers)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.USER_CREATION_INITIATOR]}
          path="/manage-roles-and-users/"
          component={protectPage(ManageRolesAndUsers)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.CREDIT_VIEWER]}
          path="/manage-loans/"
          component={protectPage(ManageLoans)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.DEAL_SLIP_APPROVER]}
          path="/manage-loans/:id/deal-slip"
          component={protectPage(UploadDealSlip)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.CREDIT_PRODUCT_APPROVE]}
          path="/manage-approvals/"
          component={protectPage(ManageApproval)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.CUSTOMER_WALLET_VIEWER]}
          path="/wallet/"
          component={protectPage(Wallet)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.CUSTOMER_WALLET_VIEWER]}
          exact={true}
          path="/company-wallets"
          component={protectPage(CompanyWallets)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.CUSTOMER_WALLET_VIEWER]}
          path="/company-wallets/transactions/"
          component={protectPage(CompanyWalletTransactions)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.CREDIT_VIEWER]}
          path="/credit-bureau/"
          component={protectPage(CreditBureau)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.DEAL_SLIP_APPROVER]}
          path="/pending-slips/"
          component={protectPage(PendingDealSlips)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.DEAL_SLIP_APPROVER]}
          path="/pending-slip"
          component={protectPage(ViewDealSlip)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.GLOBAL_SETTINGS]}
          path="/settings/"
          component={protectPage(Settings)}
        />

        <PrivateRoute
          permittedRoles={[
            ROLE_TYPES.CREDIT_PRODUCT_SETUP,
            ROLE_TYPES.CREDIT_PRODUCT_VIEWER,
          ]}
          path="/product-setup/"
          component={protectPage(ProductSetup)}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.GLOBAL_WAITLIST]}
          path="/aggregator-global-waitlist"
          component={protectPage(GlobalWaitlist)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.AGGREGATOR_ONBOARDING_VIEWER]}
          path="/aggregator-onboarding"
          component={protectPage(AggregatorOnboarding)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.AGGREGATOR_ONBOARDING_VIEWER]}
          path="/aggregator-onboarding/:id"
          component={protectPage(AggregatorOnboardingReview)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.AGGREGATOR_ONBOARDING_VIEWER]}
          path="/aggregator-onboarding/eligibility/admin"
          component={protectPage(AggregatorOnboardingEligiblityQuestions)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.AGGREGATOR_ONBOARDING_VIEWER]}
          path="/aggregator-onboarding/documents/admin"
          component={protectPage(AggregatorOnboardingRequiredDocuments)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.INVESTMENT_VIEWER]}
          path="/investor"
          component={protectPage(Investor)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.INVESTMENT_VIEWER]}
          path="/investor/:id"
          component={protectPage(InvestorTabs)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.INVESTMENT_VIEWER]}
          path="/investor/:id/investment"
          component={protectPage(EachInvestorInvestment)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.INVESTMENT_VIEWER]}
          path="/investor/:id/wallet"
          component={protectPage(InvestorInvestmentWallet)}
          exact={true}
        />

        <PrivateRoute
          permittedRoles={[ROLE_TYPES.INVESTMENT_VIEWER]}
          path="/investments"
          component={protectPage(FunderInvestmentProduct)}
          exact={true}
        />

        <Route
          path="/wallet-disbursement-transactions"
          component={protectPage(WalletDisbursementTransactions)}
          exact
        />
        {/* Wallet Disbursement Approval log */}
        <Route
          path="/wallettransactionlog/:id"
          component={protectPage(WalletTransactionLog)}
          exact
        />

        <Route
          path="/investments/create"
          component={protectPage(CreateInvestmentProduct)}
          exact
        />
        <Route
          path="/investments/:id"
          component={protectPage(ActiveInvestmentTab)}
          exact
        />
        <Route
          path="/investments/:id/edit"
          component={protectPage(EditInvestmentProduct)}
          exact
        />
        <Route
          path="/investments/preview/:id"
          component={protectPage(PreviewInvesmentFunds)}
          exact
        />
        <Route
          path="/all-investments"
          component={protectPage(AllInvestments)}
          exact
        />
        <Route
          path="/investment-details/:id"
          component={protectPage(EachFunderInvestment)}
          exact
        />
        <Route
          path="/transactions"
          component={protectPage(AllAggregatorTransactions)}
          exact
        />
        <Route
          path="/approval-requests"
          component={protectPage(ApprovalRequest)}
          exact
        />
        <Route
          path="/approval-requests/:id/investor"
          component={protectPage(PreviewInvestorDetails)}
          exact
        />
        <Route
          path="/approval-requests/:id/investment"
          component={protectPage(PreviewInvesmentFundDetails)}
          exact
        />
        <Route path="/requests" component={protectPage(Requests)} exact />

        <Route
          path="/requests/:id"
          component={protectPage(PreviewOfflineInvestment)}
          exact
        />
        <Route
          path="/loan-repayment"
          component={protectPage(BatchLoanRepayment)}
          exact
        />
        <Route
          path="/repayment-request"
          component={protectPage(BatchRepaymentRequest)}
          exact
        />
        <Route
          path="/change-password"
          component={protectPage(ChangePassword)}
        />
        <Route path="/messaging" component={protectPage(Messaging)} exact />
        <Route
          path={`/messaging/${messagingUrl.SEND_MESSAGE}`}
          component={protectPage(SendMessage)}
        />
        <Route
          path={`/messaging/${messagingUrl.PREVIOUS_MESSAGES}`}
          component={protectPage(PreviousMessages)}
        />
        <Route
          path={`/messaging/${messagingUrl.VIEW_PREVIOUS_MESSAGE}`}
          component={protectPage(ViewMessage)}
        />
        <Route
          path={`/birthday-notifications`}
          component={protectPage(BirthdayNotifications)}
        />
        <Redirect from="/*" to="/page-not-found" />
      </Switch>
      <ScrollToTop />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  const {
    authReducer: { isAuthenticated, loggedInUser },
  } = state;

  return {
    isAuthenticated,
    loggedInUser,
  };
};
export default withRouter(connect(mapStateToProps, {})(AppRouter));
